import moment from 'moment';

/**
 * Заполняет данные у виджета поиска, который рендерится вне React-компонента фильтра
 *
 * @param {string} dateStart
 * @param {string} dateEnd
 * @param {number} countGuests
 * @param {Array<number>} childrenAges
 * @param {boolean} withPet
 */
export const syncSearchWidgetData = (dateStart, dateEnd, countGuests, childrenAges, withPet) => {
  syncDatesData(dateStart, dateEnd);
  syncGuestsData(countGuests, childrenAges, withPet);
};

/**
 * @param {string} dateStart
 * @param {string} dateEnd
 */
function syncDatesData(dateStart, dateEnd) {
  if (!window.globalForm?.datePicker) return;

  const parsedDateStart = moment(dateStart, 'DD-MM-YYYY');
  const parsedDateEnd = moment(dateEnd, 'DD-MM-YYYY');
  if (parsedDateStart.isValid() && parsedDateEnd.isValid()) {
    window.globalForm.datePicker.updateDatesOutside({ startDate: parsedDateStart, endDate: parsedDateEnd });
    window.globalForm.datePicker.setNightsCount();
  }
}

/**
 * @param {number} countGuests
 * @param {Array<number>} childrenAges
 * @param {boolean} withPet
 */
function syncGuestsData(countGuests, childrenAges = [], withPet = false) {
  if (!window.globalForm?.guestsWidget) return;

  window.globalForm.guestsWidget.updateOutside(countGuests, childrenAges, withPet);
}
